export enum HomePageSections {
  ContinuePlaying = 'continue-playing',
  FeaturedGames = 'featured-games',
  AllGamesTags = 'all-games-tags',
  GZPOriginals = 'gamezop-originals',
  GameTag = 'game-tag',
  EspeciallyForYou = 'especially-for-you',
}
